import { formatRemaining } from '../../../lib/sessionGroupingUtils';
import { formatDisplayTime } from '../../../lib/dateUtils';

/**
 * Controlled 90-minute discharge timer UI for Exit/Emergency sessions.
 *
 * All three pieces are presentational: the parent orchestrator owns the store
 * (timer status + remaining ms come in as props, mutations go out as callbacks).
 * Status is idle | running | complete only — no pause (continuous discharge).
 */

/** "Started by Nathan, 9:15am" when both are known; time-only if no name. */
function attributionText(startedByName, startedAt) {
  if (startedAt == null) return null;
  const time = formatDisplayTime(startedAt);
  const name = startedByName && String(startedByName).trim();
  return name ? `Started by ${name}, ${time}` : `Started ${time}`;
}

export function SessionDesktopGroupTimer({
  status,
  remaining,
  startedByName,
  startedAt,
  onStart,
  onRequestReset,
}) {
  const started = status !== 'idle';
  const running = status === 'running';
  const finished = status === 'complete';
  const attribution = started ? attributionText(startedByName, startedAt) : null;

  return (
    <div className="session-workspace-right-timer">
      {!started && (
        <button
          type="button"
          className="btn btn-sm session-timer-primary-btn"
          onClick={onStart}
        >
          Start 90min timer
        </button>
      )}
      {running && (
        <>
          <span className="timer-countdown">Remaining: {formatRemaining(remaining)}</span>
          {attribution && <span className="session-timer-attribution">{attribution}</span>}
          <button
            type="button"
            className="btn btn-sm session-timer-secondary-btn"
            onClick={onRequestReset}
          >
            Reset
          </button>
        </>
      )}
      {finished && (
        <>
          <span className="timer-finished">90min complete</span>
          {attribution && <span className="session-timer-attribution">{attribution}</span>}
          <button
            type="button"
            className="btn btn-sm session-timer-secondary-btn"
            onClick={onRequestReset}
          >
            Reset
          </button>
        </>
      )}
    </div>
  );
}

export function SessionTimerResetDialog({ label, onConfirm, onCancel }) {
  return (
    <div className="session-timer-restart-dialog" role="dialog" aria-labelledby="session-timer-restart-title" aria-modal="true">
      <p id="session-timer-restart-title">Reset 90min timer for {label}?</p>
      <div className="session-timer-restart-actions">
        <button type="button" className="btn btn-primary" onClick={onConfirm}>
          Reset
        </button>
        <button type="button" className="btn" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}
